export const MAX_MESSAGE_LENGTH = 4000;
export function buildAssistantContext(history, content) {
    const messages = [{ role: 'user', content }];
    let characters = content.length;
    for (let index = history.length - 1; index >= 0 && messages.length < 20; index--) {
        const message = history[index];
        if (message.content.length > MAX_MESSAGE_LENGTH || characters + message.content.length > 20000)
            break;
        messages.unshift(message);
        characters += message.content.length;
    }
    if (messages[0].role === 'assistant')
        messages.shift();
    return messages;
}
export function assistantErrorKey(error) {
    const failure = error;
    if (failure?.status === 401 || failure?.status === 403)
        return 'assistant.error.authorization';
    if (failure?.status === 429)
        return 'assistant.error.rate';
    if (failure?.status === 504 || failure?.code === 'TIMEOUT_ERROR')
        return 'assistant.error.timeout';
    return 'assistant.error.unavailable';
}
